import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import { AppBar, Tab, Tabs, Typography, Paper, Button, Grid, SnackbarContent, LinearProgress } from '@material-ui/core';
import toRenderProps from 'recompose/toRenderProps';
import withState from 'recompose/withState';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { profileActionCreators } from '../../../actions/profileActionCreators';
import { getLoggedUser } from '../../../helpers';
import StudentBaseForm from './forms/StudentBaseForm';
import StudentDetailsForm from './forms/StudentDetailsForm';
import red from '@material-ui/core/colors/red';
import { withTranslation } from 'react-i18next'; // Import withTranslation

const WithState = toRenderProps(withState('anchorEl', 'updateAnchorEl', null));

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

const styles = theme => ({
    root: {
        paddingTop: theme.spacing.unit * 2,
    },
    heading: {
        marginBottom: 40,
        marginTop: 40,
    },
    snackbar: {
        backgroundColor: red[700],
        maxWidth: '100%'
    }
});

class StudentProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            file: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeIndex = this.handleChangeIndex.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        const loggedUser = getLoggedUser();
        this.props.requestStudent(this.props.match.params.id === undefined ? loggedUser.id : this.props.match.params.id);
    }

    handleChange(event, selectedTab) {
        this.setState({ selectedTab });
    }

    handleChangeIndex(index) {
        this.setState({ selectedTab: index });
    }

    handleSubmit(formPart) {
        switch (formPart) {
            case 'base':
                this.props.changePassword('student');
                break;
            case 'details':
                this.props.changeStudentDetails();
                break;
        }
    }

    render() {
        const { classes, theme, t } = this.props; // Destructure t from props
        const loggedUser = getLoggedUser();
        const student = this.props.student;

        if (!loggedUser && !loggedUser.token && loggedUser.userType !== "admin") {
            return null;
        } else {
            return (
                <Grid
                    container
                    spacing={0}
                    alignItems="center"
                    justify="center"
                >
                    <Grid item xs={12}>
                        <Paper className={classes.root}>
                            <Typography variant="h4" align="center" className={classes.heading}>
                                {t("myProfile")}
                            </Typography>
                            <Grid item xs={12}>
                                {student.cv == null ? (
                                    <SnackbarContent
                                        className={classes.snackbar}
                                        message={t("importantMessage")}
                                    />
                                ) : null}
                            </Grid>
                            <AppBar position="static" color="default">
                                <Tabs
                                    value={this.state.selectedTab}
                                    onChange={this.handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    fullWidth
                                >
                                    <Tab label={t("profileData")} />
                                    <Tab label={t("personalData")} />
                                </Tabs>
                            </AppBar>
                            <SwipeableViews
                                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                index={this.state.selectedTab}
                                onChangeIndex={this.handleChangeIndex}
                            >
                                <div dir={theme.direction}>
                                    <Grid
                                        container
                                        spacing={0}
                                        alignItems="center"
                                        justify="center"
                                    >
                                        <Grid item xs={12} sm={4}>
                                            <StudentBaseForm
                                                initialValues={{
                                                    email: student.email
                                                }}
                                                onSubmit={() => this.handleSubmit('base')}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div dir={theme.direction}>
                                    <Grid
                                        container
                                        spacing={0}
                                        alignItems="center"
                                        justify="center"
                                    >
                                        <Grid item xs={12} sm={6}>
                                            <StudentDetailsForm
                                                initialValues={{
                                                    firstName: student.firstName,
                                                    middleName: student.middleName,
                                                    lastName: student.lastName,
                                                    email: student.email,
                                                    facultyNumber: student.facultyNumber,
                                                    degree: student.degree,
                                                    isGraduated: student.isGraduated + '',
                                                    school: student.school,
                                                    speciality: student.speciality,
                                                    phone: student.phone,
                                                    cvFile: student.cvFile,
                                                    cv: student.cv
                                                }}
                                                cvName={student.cv}
                                                onSubmit={() => this.handleSubmit('details')}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </SwipeableViews>
                        </Paper>
                    </Grid>
                </Grid>
            );
        }
    }
}

const mapStateToProps = state => ({
    ...state.profiles
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(profileActionCreators, dispatch)
});

export default withStyles(styles, { withTheme: true })(
    withTranslation()( // Wrap with withTranslation
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(StudentProfile)
    )
);

//import React, { Component } from 'react';
//import { withStyles } from '@material-ui/core/styles';
//import SwipeableViews from 'react-swipeable-views';
//import { AppBar, Tab, Tabs, Typography, Paper, Button, Grid, Snackbar, SnackbarContent } from '@material-ui/core';
//import toRenderProps from 'recompose/toRenderProps';
//import withState from 'recompose/withState';
//import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { profileActionCreators } from '../../../actions/profileActionCreators';
//import { getLoggedUser } from '../../../helpers';
//import StudentBaseForm from './forms/StudentBaseForm';
//import StudentDetailsForm from './forms/StudentDetailsForm';
//import red from '@material-ui/core/colors/red';


//const WithState = toRenderProps(withState('anchorEl', 'updateAnchorEl', null));

//function TabContainer({ children, dir }) {
//    return (
//        <Typography component="div" dir={dir}>
//            {children}
//        </Typography>
//    );
//}

//const styles = theme => ({
//    root: {
//        paddingTop: theme.spacing.unit * 2,
//    },
//    heading: {
//        marginBottom: 40,
//        marginTop: 40,
//    },
//    snackbar: {
//        backgroundColor: red[700],
//        maxWidth: '100%'
//    }
//});

//class StudentProfile extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            selectedTab: 0,
//            file: {}
//        };

//        this.handleChange = this.handleChange.bind(this);
//        this.handleChangeIndex = this.handleChangeIndex.bind(this);
//        this.handleSubmit = this.handleSubmit.bind(this);
//    }

//    componentWillMount() {
//        const loggedUser = getLoggedUser();

//        this.props.requestStudent(this.props.match.params.id === undefined ? loggedUser.id : this.props.match.params.id);
//    }

//    handleChange(event, selectedTab) {
//        this.setState({ selectedTab });
//    };

//    handleChangeIndex(index) {
//        this.setState({ selectedTab: index });
//    };

//    handleSubmit(formPart) {


//        switch (formPart) {
//            case 'base':
//                this.props.changePassword('student');
//                break;
//            case 'details':
//                this.props.changeStudentDetails();
//                break;
//        }
//    }

//    render() {
//        const { classes, theme } = this.props;
//        const loggedUser = getLoggedUser();
//        const student = this.props.student;

//        if (!loggedUser && !loggedUser.token &&
//            loggedUser.userType !== "admin") {
//            return (null);
//        } else {

//            return (
//                <Grid
//                    container
//                    spacing={0}
//                   // direction="column"
//                    alignItems="center"
//                   justify="center"
//                >
//                    <Grid item xs={12}>
//                        <Paper className={classes.root}>
//                            <Typography variant="h4" align="center" className={classes.heading}>
//                                Моят профил
//                            </Typography>
//                            <Grid item xs={12}>
//                                {student.cv == null ?
//                                    (<SnackbarContent gutterBottom
//                                        aria-describedby="client-snackbar" className={classes.snackbar}
//                                        message={
//                                            <span id="client-snackbar">
//                                                ВАЖНО: За да активирате вашия профил, трябва да качите CV!
//                                                        </span>
//                                        }
//                                    />)
//                                    : null}
//                            </Grid>
//                            <AppBar position="static" color="default">
//                                <Tabs
//                                    value={this.state.selectedTab}
//                                    onChange={this.handleChange}
//                                    indicatorColor="primary"
//                                    textColor="primary"
//                                    fullWidth
//                                >
//                                    <Tab label="Данни за профила" />
//                                    <Tab label="Лични данни" />
//                                </Tabs>
//                            </AppBar>

//                            <SwipeableViews
//                                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
//                                index={this.state.selectedTab}
//                                onChangeIndex={this.handleChangeIndex}
//                            >
//                                <TabContainer dir={theme.direction}>
//                                    <Grid
//                                        container
//                                        spacing={0}
//                                       // direction="column"
//                                        alignItems="center"
//                                       justify="center"
//                                    >
//                                        <Grid item xs={12} sm={4}>
//                                            <StudentBaseForm
//                                                initialValues={{
//                                                    email: student.email
//                                                }}
//                                                onSubmit={() => this.handleSubmit('base')} />
//                                        </Grid>
//                                    </Grid>
//                                </TabContainer>
//                                <TabContainer dir={theme.direction}>
//                                    <Grid
//                                        container
//                                        spacing={0}
//                                       // direction="column"
//                                        alignItems="center"
//                                       justify="center"
//                                    >
//                                        <Grid item xs={12} sm={6}>
//                                            <StudentDetailsForm
//                                                initialValues={{
//                                                    firstName: student.firstName,
//                                                    middleName: student.middleName,
//                                                    lastName: student.lastName,
//                                                    email: student.email,
//                                                    facultyNumber: student.facultyNumber,
//                                                    degree: student.degree,
//                                                    isGraduated: student.isGraduated + '',
//                                                    school: student.school,
//                                                    speciality: student.speciality,
//                                                    phone: student.phone,
//                                                    cvFile: student.cvFile,
//                                                    cv: student.cv
//                                                }}
//                                                cvName={student.cv}
//                                                onSubmit={() => this.handleSubmit('details')} />
//                                        </Grid>
//                                    </Grid>
//                                </TabContainer>
//                            </SwipeableViews>
//                        </Paper>
//                    </Grid>
//                </Grid>
//            );
//        }
//    }
//}

//export default withStyles(styles, { withTheme: true })(connect(
//    state => state.profiles,
//    dispatch => bindActionCreators(profileActionCreators, dispatch)
//)(StudentProfile));